"use strict";
var FromEventObservable_1 = require('./FromEventObservable');
exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/~/rxjs/observable/fromEvent.js
// module id = ../../../../rxjs/observable/fromEvent.js
// module chunks = 4